import React, { useState, useRef } from 'react'

import {
  TagsList, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  array, bool, func,
} from 'prop-types'


import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import Action from './Components/Action'
import CustomButtonFilter from './Components/CustomButtonFilter'
import MockedTagsRow from './Components/MockedTagsRow'

function ModelSearchTags({
  tags = EMPTY_ARRAY,
  onDeleteTagClick = NOOP,
  onClearAllClick = NOOP,
  hideControls = false,
  extractingCoreStyles = false,
  useWhiteBackground = false,
}) {
  const [isClearActive, setIsClearActive] = useState(false)
  const listRef = useRef(null)

  const hasTags = tags && tags.length
  const hasActiveTags = (tags || []).some(tag => tag.enabled)

  const slide = (direction) => {
    const currentTagList = listRef

    if (direction === 'right') {
      return currentTagList.current.scrollLeft += 150
    }

    return currentTagList.current.scrollLeft -= 150
  }

  if (extractingCoreStyles) {
    return (
      <MockedTagsRow />
    )
  }

  if (!hasTags) {
    return null
  }

  return (
    <div className={classnames('cgt-model-search__tag-list', useWhiteBackground && 'cgt-legacy-back-color-white-100')}>
      {!hideControls && (
        <div
          className={classnames(
            'cgt-model-search__tag-list-reset',
            isClearActive && 'cgt-model-search__tag-list-reset--active',
          )}
        >
          {hasActiveTags && (
            <Action icon="Close" onClick={onClearAllClick} />
          )}
        </div>
      )}
      <div className="cgt-model-search__tag-list-tags" ref={listRef}>
        <div className="cgt-model-search__tag-list-body">
          <TagsList
            tags={tags}
            onDeleteClick={onDeleteTagClick}
            Component={CustomButtonFilter}
          />
        </div>
      </div>
      {!hideControls && (
        <div className="cgt-model-search__tag-list-navigation">
          <Action icon="ArrowLeft" onClick={() => slide('left')} />
          <Action icon="ArrowRight" onClick={() => slide('right')} />
        </div>
      )}
    </div>
  )
}

ModelSearchTags.propTypes = {
  tags: array,
  onDeleteTagClick: func,
  onClearAllClick: func,
  hideControls: bool,
  extractingCoreStyles: bool,
  useWhiteBackground: bool,
}

export default ModelSearchTags
